var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"30","height":"30","viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21.634 16.383c1.86-.022 1.86-2.809 0-2.787-7.821-.014-12.352-.014-13.592 0-1.86.023-1.86 2.81 0 2.787h13.592z","fill":"#5C40B3","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }